import { Collapse, IconButton, Alert as MuiAlert } from '@mui/material';
import { useEffect, useState } from 'react';
import { CloseIcon } from '../../../mui/Icons';
import styles from './Alert.module.scss';
import classNames from 'classnames';

// Eventually, we should move this to the reducer that defines it
export type AlertState = {
	id: string;
	message: string;
	routes?: string[];
	isRemove?: boolean;
	time: string;
};

export type AlertProps = {
	alert: AlertState;
	currentRoute: string;
	gutterTop?: true;
	triggerClose?: true;
	onExited?: () => void;
};

export const Alert: React.FC<AlertProps> = ( {
	alert,
	currentRoute,
	gutterTop,
	triggerClose,
	onExited,
} ) => {
	const [ open, setOpen ] = useState( false );

	useEffect( () => {
		if ( triggerClose ) {
			setOpen( false );
		}
	}, [ triggerClose ] );

	useEffect( () => {
		setOpen( ( prevState ) => prevState || true );
	}, [ alert ] );

	useEffect( () => {
		if ( alert.routes && !alert.routes.includes( currentRoute ) ) {
			setOpen( false );
		} else if ( alert.routes && alert.routes.includes( currentRoute ) ) {
			setOpen( true );
		}
	}, [ alert.routes, currentRoute ] );

	return (
		<Collapse in={ open } onExited={ onExited }>
			<MuiAlert
				className={ classNames(
					styles.alert,
					gutterTop ? styles.gutterTop : undefined
				) }
				severity='info'
				action={
					<IconButton onClick={ () => setOpen( false ) }>
						<CloseIcon className={ styles.icon } />
					</IconButton>
				}
			>
				{ alert.message }
			</MuiAlert>
		</Collapse>
	);
};
